import { FC, useState } from "react";
import { kebabCase } from "lodash";

import { EssentialImage } from "components";

interface RoyaltyPayorLogoProps {
  displayName: string;
  logoImage?: string;
  className?: string;
}

const RoyaltyPayorLogo: FC<RoyaltyPayorLogoProps> = ({
  displayName,
  logoImage,
  className,
}) => {
  const [logoExists, setLogoExists] = useState(true);
  const imageSrc =
    logoImage ||
    `${import.meta.env.REACT_APP_MEDIA_URL}/royalty_payors_logos/${kebabCase(
      displayName?.toLowerCase(),
    )}.svg`;
  const handleImageError = () => {
    setLogoExists(false);
  };

  return (
    <>
      {logoExists && (!!displayName || !!logoImage) ? (
        <EssentialImage>
          <img
            src={imageSrc}
            alt={displayName}
            onError={handleImageError}
            className={className}
          />
        </EssentialImage>
      ) : (
        displayName
      )}
    </>
  );
};

export default RoyaltyPayorLogo;
